export const facilityAdmins = {
    'poojitha@trackonomysystems.com': 'PtVy#i9$1ayb@',
    'rohitsharma@trackonomysystems.com': 'RtSy$21!acc*',
    'bodhi@trackonomysystems.com': 'BdT!2024#sys',
    'chrisgordon@ups.com': 'CgUps@4secure!',
    'pccollins@ups.com': 'PcUps#33!work',
    'mshoals@ups.com': 'Ms@UPStech20!',
    'macolon@ups.com': 'McU$2023*safe!',
    'salvi@ups.com': 'SliUps!92*work',
    'mzarzecki@ups.com': 'MzU$safe2023!',
    'vpizzuto@ups.com': 'VpU@secure99!',
    'joshuawilson@ups.com': 'JoW!Ups@1287',
    'jchava@ups.com': 'JcW$Ups@8790',
    'jdurako@ups.com': 'Pav#Ups@4457'
};
export function isFacilityAdmin(email, password) {
    return facilityAdmins[email] === password;
}